import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { 
  Users, QrCode, Calendar, Share2, 
  Network, MapPin, Clock, ArrowRight 
} from 'lucide-react';

const DigiConnectLanding = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <Users className="w-8 h-8" />,
      title: "Digital Business Cards",
      description: "Create and share modern, interactive digital business cards with QR codes and NFC support. No login required for visitors!"
    },
    {
      icon: <QrCode className="w-8 h-8" />,
      title: "Smart Lead Capture",
      description: "When someone scans your QR code, capture their name and phone automatically. Get instant notifications!"
    },
    {
      icon: <Share2 className="w-8 h-8" />,
      title: "Contact Groups",
      description: "Organize contacts into groups and share them via a single QR code. Perfect for events and team sharing"
    },
    {
      icon: <MapPin className="w-8 h-8" />,
      title: "Nearby Connect",
      description: "Discover and connect with professionals in your area based on business categories"
    },
    {
      icon: <Network className="w-8 h-8" />,
      title: "Business Card Scanner",
      description: "Take a photo of physical business cards and instantly digitize them with AI-powered OCR"
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Contact Tracking & Analytics",
      description: "Know exactly who downloads your contact, when, and from where. Email notifications included"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-slate-50">
      {/* Hero Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Digi<span className="text-blue-600">Connect</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Transform Your Professional Networking with Digital Business Cards & Smart Connections
          </p>
          <div className="flex gap-4 justify-center flex-wrap">
            <Button
              onClick={() => navigate('/auth')}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg rounded-full"
            >
              Get Started Free <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              onClick={() => navigate('/digi-connect')}
              variant="outline"
              className="px-8 py-6 text-lg rounded-full border-2 border-blue-600 text-blue-600 hover:bg-blue-50"
            >
              Learn More
            </Button>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="text-blue-600 mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-3xl p-12 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Transform Your Networking?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Join thousands of professionals using DigiConnect
          </p>
          <Button
            onClick={() => navigate('/auth')}
            className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-full font-semibold"
          >
            Start Connecting Today
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DigiConnectLanding;
